var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 4.47716 4.47715 0 10 0H109C114.523 0 119 4.47715 119 10V114H0V10Z",
  fill: "#FF9E22",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59 89C76.6731 89 91 74.6731 91 57C91 39.3269 76.6731 25 59 25C41.3269 25 27 39.3269 27 57C27 74.6731 41.3269 89 59 89Z",
  fill: "#FF9E22"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9102 59.7041L66.3554 88.1494C78.1738 85.3694 87.4655 76.0386 90.1872 64.1979L82.9893 57L37.9102 59.7041Z",
  fill: "#E17726"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M82.9887 56.9999C82.9887 56.9999 72.3338 70.1355 59.1902 70.1355C46.0466 70.1355 35.3918 56.9999 35.3918 56.9999C35.3918 56.9999 46.0467 43.8643 59.1903 43.8643C72.334 43.8643 82.9887 56.9999 82.9887 56.9999Z",
  fill: "#EEF4FF"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M82.9889 56.9999C82.9889 56.9999 72.3341 70.1355 59.1904 70.1355V43.8643C72.3341 43.8643 82.9889 56.9999 82.9889 56.9999Z",
  fill: "#D6E9F8"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M59.1908 69.3456C66.0094 69.3456 71.537 63.818 71.537 56.9995C71.537 50.1809 66.0094 44.6533 59.1908 44.6533C52.3723 44.6533 46.8447 50.1809 46.8447 56.9995C46.8447 63.818 52.3723 69.3456 59.1908 69.3456Z",
  fill: "#804111"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M71.537 56.9995C71.537 63.8181 66.0094 69.3456 59.1909 69.3456V44.6533C66.0095 44.6533 71.537 50.1809 71.537 56.9995Z",
  fill: "#62320D"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M66.9538 56.9995C66.9538 61.2868 63.4781 64.7626 59.1906 64.7626C55.7418 64.7626 52.8181 62.5136 51.8065 59.4021L51.7859 54.6613C52.7779 51.5165 55.718 49.2363 59.1906 49.2363C63.478 49.2365 66.9538 52.7121 66.9538 56.9995Z",
  fill: "#464646"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7867 54.6611C51.5539 55.3991 51.4277 56.1844 51.4277 56.9993C51.4277 57.838 51.5624 58.6449 51.8085 59.4016L56.5381 57.0369L51.7867 54.6611Z",
  fill: "#EEF4FF"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M66.954 56.9995C66.954 52.7121 63.4784 49.2363 59.1909 49.2363V64.7626C63.4783 64.7626 66.954 61.287 66.954 56.9995Z",
  fill: "#2D2D2D"
});
function SvgSymptomItchyEyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomItchyEyes);
export default __webpack_public_path__ + "static/media/symptom-Itchy-Eyes.7195f055585c679d19e5f8a2b097e12e.svg";
export { ForwardRef as ReactComponent };